module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('v-navigation-drawer', {
    attrs: {
      "temporary": "",
      "enable-resize-watcher": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": require('./assets/DOB-Energy-Logo-RGB_Horizontal-Colour-geoLOGIC-Tag-left.png')
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "app-title"
  }, [_vm._v("Assets for Sale")])], 1), _vm._v(" "), _c('v-list-tile-action', {
    staticClass: "menu-chevron"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "light": ""
    }
  }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    staticClass: "app-menu-item",
    attrs: {
      "tag": "div"
    }
  }, [_c('v-list-tile-action', [_c('v-switch', {
    attrs: {
      "color": "primary",
      "light": ""
    },
    model: {
      value: (_vm.assetManager),
      callback: function($$v) {
        _vm.assetManager = $$v
      },
      expression: "assetManager"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Assets")])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', {
    staticStyle: {
      "padding-left": "40px"
    },
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-action', [_c('v-switch', {
    attrs: {
      "color": "primary",
      "light": "",
      "disabled": !_vm.assetManager
    },
    model: {
      value: (_vm.royaltyLayer),
      callback: function($$v) {
        _vm.royaltyLayer = $$v
      },
      expression: "royaltyLayer"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("\r\n            Royalty\r\n          ")]), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
    staticStyle: {
      "color": "#0085b1"
    },
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("\r\n              stop\r\n            ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticStyle: {
      "padding-left": "40px"
    },
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-action', [_c('v-switch', {
    attrs: {
      "color": "primary",
      "light": "",
      "disabled": !_vm.assetManager
    },
    model: {
      value: (_vm.productionLayer),
      callback: function($$v) {
        _vm.productionLayer = $$v
      },
      expression: "productionLayer"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("\r\n            Production\r\n          ")]), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
    staticStyle: {
      "color": "#ef5534"
    },
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("\r\n              stop\r\n            ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticStyle: {
      "padding-left": "40px"
    },
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-action', [_c('v-switch', {
    attrs: {
      "color": "primary",
      "light": "",
      "disabled": !_vm.assetManager
    },
    model: {
      value: (_vm.landLayer),
      callback: function($$v) {
        _vm.landLayer = $$v
      },
      expression: "landLayer"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("\r\n            Land\r\n          ")]), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
    staticStyle: {
      "color": "#85a800"
    },
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("\r\n              stop\r\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "tag": "div"
    }
  }, [_c('v-list-tile-action', [_c('v-switch', {
    attrs: {
      "color": "primary",
      "light": ""
    },
    model: {
      value: (_vm.pipelineLayer),
      callback: function($$v) {
        _vm.pipelineLayer = $$v
      },
      expression: "pipelineLayer"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Pipelines")])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', {
    staticStyle: {
      "padding-left": "40px"
    },
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-title', [_vm._v("\r\n            Oil\r\n          ")]), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
    staticStyle: {
      "color": "#e41a1c"
    },
    attrs: {
      "large": ""
    }
  }, [_vm._v("\r\n              drag_handle\r\n            ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticStyle: {
      "padding-left": "40px"
    },
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-title', [_vm._v("\r\n            Gas\r\n          ")]), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
    staticStyle: {
      "color": "#4DAF4A"
    },
    attrs: {
      "large": ""
    }
  }, [_vm._v("\r\n              drag_handle\r\n            ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticStyle: {
      "padding-left": "40px"
    },
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-title', [_vm._v("\r\n            Multiuse\r\n          ")]), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
    staticStyle: {
      "color": "#377EB8"
    },
    attrs: {
      "large": ""
    }
  }, [_vm._v("\r\n              drag_handle\r\n            ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticStyle: {
      "padding-left": "40px"
    },
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-title', [_vm._v("\r\n            Not Indentified\r\n          ")]), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
    staticStyle: {
      "color": "#984EA3"
    },
    attrs: {
      "large": ""
    }
  }, [_vm._v("\r\n              drag_handle\r\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "tag": "div"
    }
  }, [_c('v-list-tile-action', [_c('v-switch', {
    attrs: {
      "color": "primary",
      "light": ""
    },
    model: {
      value: (_vm.gridLayer),
      callback: function($$v) {
        _vm.gridLayer = $$v
      },
      expression: "gridLayer"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Township Grid")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "light": ""
    }
  }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.tour()
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Take a Tour")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "mailto:customerservice@dobenergy.com",
      "target": "_blank"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Get Help")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "app-toolbar white elevation-1",
    attrs: {
      "floating": "",
      "dense": ""
    }
  }, [_c('v-toolbar-side-icon', {
    staticClass: "app-menu-icon",
    attrs: {
      "light": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "app-search-box",
    attrs: {
      "prepend-icon": "search",
      "hide-details": "",
      "single-line": "",
      "placeholder": "Search for Assets"
    },
    on: {
      "input": _vm.onInput,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.isOpen = false
      }
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }), _vm._v(" "), _c('v-dialog', {
    staticClass: "app-date-filter",
    attrs: {
      "lazy": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dateDialog),
      callback: function($$v) {
        _vm.dateDialog = $$v
      },
      expression: "dateDialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "blue--text"
  }, [_vm._v("access_time")])], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Filter by posting date")])]), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "padding": "0 16px"
    }
  }, [_c('v-btn', {
    staticClass: "blue-grey lighten-3 elevation-0 white--text",
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dateDialog = false, _vm.filterByLastQuarter()
      }
    }
  }, [_vm._v("Last QTR")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue-grey lighten-3 elevation-0 white--text",
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dateDialog = false, _vm.filterByThisQuarter()
      }
    }
  }, [_vm._v("This QTR")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.startDateMenu),
      callback: function($$v) {
        _vm.startDateMenu = $$v
      },
      expression: "startDateMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "From",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "autosave": ""
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.endDateMenu),
      callback: function($$v) {
        _vm.endDateMenu = $$v
      },
      expression: "endDateMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "To",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "autosave": ""
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dateDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dateDialog = false, _vm.filterByDate()
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    staticClass: "app-table-view",
    attrs: {
      "lazy": "",
      "persistent": "",
      "fullscreen": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.listDialog),
      callback: function($$v) {
        _vm.listDialog = $$v
      },
      expression: "listDialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "blue--text"
  }, [_vm._v("view_list")])], 1), _vm._v(" "), _c('v-card', [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.listDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("List of Assets")])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.listSearch),
      callback: function($$v) {
        _vm.listSearch = $$v
      },
      expression: "listSearch"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.listDataTableHeaders,
      "items": _vm.assetData,
      "search": _vm.listSearch
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "width": "150px"
          }
        }, [_vm._v(_vm._s(props.item.area))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "width": "150px"
          }
        }, [_vm._v(_vm._s(props.item.asset_type))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "width": "200px"
          }
        }, [_vm._v(_vm._s(props.item.company))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "width": "150px"
          }
        }, [_vm._v(_vm._s(props.item.agent))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "width": "200px"
          }
        }, [_vm._v(_vm._s(props.item.bid_date))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left",
          domProps: {
            "innerHTML": _vm._s(props.item.description)
          }
        })]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\r\n                From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + "\r\n            ")]
      }
    }])
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "app-search-tags"
  }, [_c('v-chip', {
    staticClass: "primary white--text elevation-1 app-search-tag",
    attrs: {
      "close": ""
    },
    model: {
      value: (_vm.tagCompany),
      callback: function($$v) {
        _vm.tagCompany = $$v
      },
      expression: "tagCompany"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("business")]), _vm._v("\r\n      " + _vm._s(_vm.selectedCompany) + "\r\n    ")], 1), _vm._v(" "), _c('v-chip', {
    staticClass: "primary white--text elevation-1 app-search-tag",
    attrs: {
      "close": ""
    },
    model: {
      value: (_vm.tagArea),
      callback: function($$v) {
        _vm.tagArea = $$v
      },
      expression: "tagArea"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("select_all")]), _vm._v("\r\n      " + _vm._s(_vm.selectedArea) + "\r\n    ")], 1), _vm._v(" "), _c('v-chip', {
    staticClass: "primary white--text elevation-1 app-search-tag",
    attrs: {
      "close": ""
    },
    model: {
      value: (_vm.tagAdvisor),
      callback: function($$v) {
        _vm.tagAdvisor = $$v
      },
      expression: "tagAdvisor"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("person")]), _vm._v("\r\n      " + _vm._s(_vm.selectedAdvisor) + "\r\n    ")], 1), _vm._v(" "), _c('v-chip', {
    staticClass: "primary white--text elevation-1 app-search-tag",
    attrs: {
      "close": ""
    },
    model: {
      value: (_vm.tagDate),
      callback: function($$v) {
        _vm.tagDate = $$v
      },
      expression: "tagDate"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("access_time")]), _vm._v("\r\n      " + _vm._s(_vm.selectedDate) + "\r\n    ")], 1)], 1), _vm._v(" "), _c('v-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "autocomplete-list elevation-1"
  }, [_vm._l((_vm.filteredItems), function(item, index) {
    return [(_vm.hasResults === true) ? _c('v-list-tile', {
      key: index,
      staticClass: "autocomplete-list-item",
      nativeOn: {
        "click": function($event) {
          _vm.select(index)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.value)
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), (index < _vm.searchResult.length - 1) ? _c('v-divider') : _vm._e()]
  })], 2), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view', {
    attrs: {
      "name": "Map"
    }
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbarTimeout,
      "top": _vm.snackbarY === 'top',
      "bottom": _vm.snackbarY === 'bottom',
      "right": _vm.snackbarX === 'right',
      "left": _vm.snackbarX === 'left',
      "multi-line": _vm.snackbarMode === 'multi-line',
      "vertical": _vm.snackbarMode === 'vertical',
      "success": _vm.snackbarContext === 'success',
      "error": _vm.snackbarContext === 'error'
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\r\n    " + _vm._s(_vm.snackbarText) + "\r\n    "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeSnackbar($event)
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.assetsLayer
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.assetData
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.snackbar
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.snackbarContext
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.snackbarTimeout
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.snackbarText
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.townshipHighlightLayer
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05c2301e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 545
// module chunks = 1